import { app } from "./main-app";
import mitt from "mitt";
export const emitter = mitt();

app.provide("emitter", emitter);
